import { createI18n } from 'vue-i18n'
import zhCN from '@/locale/zh-CN.js'
import enUS from '@/locale/en-US.js'

const LOCALE_KEY = 'adminLocale'

export function getSavedLocale() {
  return localStorage.getItem(LOCALE_KEY) || 'zh-CN'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getSavedLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
})

export function setAppLocale(locale) {
  if (!i18n.global.availableLocales.includes(locale)) return
  i18n.global.locale.value = locale
  localStorage.setItem(LOCALE_KEY, locale)
  document.documentElement.lang = locale === 'en-US' ? 'en' : 'zh-CN'
}

export default i18n
